/**
 * Please sort keys
 */
export enum FunnelExperimentId {
    ACT_TEST = 'ACT-TEST',
    ACT_3321 = 'ACT-3321',
    ACT_3489 = 'ACT-3489',
    ACT_3881 = 'ACT-3881',
    ACT_4032 = 'ACT-4032',
    ACT_4093 = 'ACT-4093',
    ACT_4175 = 'ACT-4175',
    ACT_4285 = 'ACT-4285',
    ACT_4519 = 'ACT-4519',
    ACT_4566 = 'ACT-4566',
    ACT_4576 = 'ACT-4576',
    ACT_4582 = 'ACT-4582',
    ACT_4585 = 'ACT-4585',
    ACT_4598 = 'ACT-4598',
    ACT_4602 = 'ACT-4602',
    ACT_4603 = 'ACT-4603',
    ACT_4606 = 'ACT-4606',
    ACT_4608 = 'ACT-4608',
    ACT_4657 = 'ACT-4657',
    ACT_4712 = 'ACT-4712',
    ACT_4844 = 'ACT-4844',
    ACT_4894 = 'ACT-4894',
    ACT_4922 = 'ACT-4922',
    ACT_4926 = 'ACT-4926',
    ACT_4944 = 'ACT-4944',
    ACT_4968 = 'ACT-4968',
    ACT_5036 = 'ACT-5036',
    ACT_5038 = 'ACT-5038',
    ACT_5130 = 'ACT-5130',
    ACT_5120 = 'ACT-5120',
    ACT_5136 = 'ACT-5136',
    ACT_5137 = 'ACT-5137',
    ACT_5182 = 'ACT-5182',
    ACT_5210 = 'ACT-5210',
    ACT_5328 = 'ACT-5328',
    ACT_5236 = 'ACT-5236',
    ACT_5289 = 'ACT-5289',
    ACT_5340 = 'ACT-5340',
    ACT_5365 = 'ACT-5365',
    ACT_5408 = 'ACT-5408',
    ACT_5425 = 'ACT-5425',
    ACT_5475 = 'ACT-5475',
    ACT_5500 = 'ACT-5500',
    ACT_5551 = 'ACT-5551',

    ACTD_5 = 'ACTD-5',
    ACTD_8 = 'ACTD-8',
    ACTD_9 = 'ACTD-9',

    AWL_581 = 'AWL-581',
    AWL_779 = 'AWL-779',
}

export enum SupplyExperimentId {
    ABE_4553 = 'ABE-4553',
}

export enum SupplyOptimizationExperimentId {}

export enum MarketingExperimentId {
    ACTB_AUTO_APPLIED_PRICE_PEEK = 'ACTB-AAPP-FE',
    ACTB_1538 = 'ACTB-1538',
    ACTB_MSE = 'ACTB-MSE',
    ACTB_1820 = 'ACTB-1820',
    ACTB_1823 = 'ACTB-1823',
}

export enum BookingExperimentId {
    AFT_218 = 'AFT-218',
    AFT_1622 = 'AFT-1622',
    AFT_1666 = 'AFT-1666',
}

export enum ExternalDroneExperimentId {
    ADSEFF_309 = 'ADSEFF-309',
}

export enum HeaderExperimentId {
    AVENGERS_1655 = 'AVENGERS-1655',
}

export enum TripsExperimentId {
    REMOVE_CART_WL_HARDCODINGS = 'WLBC-1059',
    MPW_SAVED_ACTIVITIES_TO_CART = 'MPW-SAVED-ACTIVITIES-TO-CART',
    MPW_2721 = 'MPW-2721',
    MigrateSimpleComponentsToDroneCartJS = 'WLBE-73',
    MigrateButtonToDroneCartJS = 'WLBE-75',
    MigrateTypographyToDroneCartJS = 'WLBE-79',
    MigrateBoxToDroneCartJSPt1 = 'WLBE-1422',
    MigrateAlertAndDottedProgressToDroneCartJS = 'WLBE-1421',
}

export enum UniversalLoginExperimentId {
    USE_NEW_SESSION_PACKAGE = 'ACC-2335',
}

export enum TripMarketingWebExperimentId {
    ENHANCE_UCS_ACTIVITY_CARD = 'TMKTWEB-UCS-ACTIVITIES-LEVELUP',
}

export const ExperimentId = {
    ...FunnelExperimentId,
    ...SupplyExperimentId,
    ...SupplyOptimizationExperimentId,
    ...MarketingExperimentId,
    ...BookingExperimentId,
    ...ExternalDroneExperimentId,
    ...HeaderExperimentId,
    ...TripsExperimentId,
    ...UniversalLoginExperimentId,
    ...TripMarketingWebExperimentId,
};

// eslint-disable-next-line no-redeclare
export type ExperimentId =
    | FunnelExperimentId
    | SupplyExperimentId
    | SupplyOptimizationExperimentId
    | MarketingExperimentId
    | HeaderExperimentId
    | BookingExperimentId
    | ExternalDroneExperimentId
    | TripsExperimentId
    | UniversalLoginExperimentId
    | TripMarketingWebExperimentId;
